import { Navbar } from "@/components/Navbar";
import { Clock, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      
      {/* Hero Section */}
      <section className="container mx-auto px-4 py-20">
        <div className="text-center animate-fade-in">
          <h1 className="text-4xl md:text-5xl font-light tracking-wide text-primary mb-6">
            3° Tabelionato de Protesto de Curitiba
          </h1>
          <div className="max-w-3xl mx-auto space-y-4 text-gray-600">
            <h2 className="text-2xl font-semibold text-primary mt-6 mb-4">
              Protesto de Títulos: um instrumento de concretização de direitos
            </h2>
            <p className="text-lg mb-4">
              Você sabia que o Protesto extrajudicial é um instrumento socioeconômico para a satisfação de obrigações e prevenção de litígios?
            </p>
            <p className="text-lg">
              Os Tabelionatos de Protesto promovem acesso à justiça de forma ampla, aproximando credor e devedor, oportunizando a solução extrajudicial de demandas que acabariam aportando nos tribunais.
            </p>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="bg-secondary py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <InfoCard
              icon={Clock}
              title="Horário de Atendimento"
              description="Segunda a Sexta: 8h30 às 17h (Não fechamos para almoço)"
            />
            <InfoCard
              icon={Phone}
              title="Contatos"
              description={
                <div className="space-y-2">
                  <p>Telefone: (41) 3352-9081</p>
                  <a 
                    href="https://wa.me/554133529081" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline inline-block"
                  >
                    WhatsApp: (41) 3352-9081
                  </a>
                  <p>
                    <a 
                      href="mailto:curitiba@terceiroprotesto.com.br"
                      className="text-primary hover:underline"
                    >
                      curitiba@terceiroprotesto.com.br
                    </a>
                  </p>
                </div>
              }
            />
            <InfoCard
              icon={MapPin}
              title="Localização"
              description="Rua Doutor Roberto Barrozo, 577, esquina com a Rua Nilo Peçanha, bairro São Francisco, Curitiba-PR. CEP 80520-070"
            />
          </div>
          <div className="text-center">
            <Link 
              to="/politica-de-privacidade" 
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              Política de Privacidade
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

const InfoCard = ({
  icon: Icon,
  title,
  description,
}: {
  icon: any;
  title: string;
  description: string | JSX.Element;
}) => (
  <div className="bg-white p-6 rounded-lg shadow-sm animate-slide-in">
    <Icon className="w-8 h-8 text-primary mb-4" />
    <h3 className="font-semibold text-lg mb-2">{title}</h3>
    {typeof description === "string" ? (
      <p className="text-gray-600">{description}</p>
    ) : (
      <div className="text-gray-600">{description}</div>
    )}
  </div>
);

export default Index;